import { t } from '@lingui/macro';

import { isArrEmpty } from '../utils/arrayUtil';

export const STAFF_FILTER_NAME = 'staff';

const useReadStaffChoices = (isStaffFilterActive, isStaffFilterForced, staffs) => {
  // sometimes on normal BE, users can still force the staff parameter to view their availabilities etc...
  // in that case we will display the filter but disabled, the staff is not changeable
  const displayStaffFilter = isStaffFilterActive || isStaffFilterForced;

  const all = t({
    id: 'ALL_MASCULINE',
    message: 'All',
  });

  const choices = [{ label: all, value: '' }];

  if (displayStaffFilter && !isArrEmpty(staffs)) {
    for (const staff of staffs) {
      choices.push({ label: staff.first_name.trim() + ' ' + staff.last_name.trim(), value: staff.user_id });
    }
  }

  return { displayStaffFilter, choicesStaffFilter: choices };
};

export default useReadStaffChoices;
